import __request__ from "routing/request";
export function get(nodeId) {
  return __request__("GET", `/cluster/${nodeId}/journal`, null, {}, {
    "Accept": ["application/json"]
  });
}
